exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subOption[data-v-418aa29e] {\n  font-size: 14px;\n}\n.subOption input[data-v-418aa29e]::-webkit-input-placeholder {\n  font-size: 14px;\n}\n.label-switch[data-v-418aa29e] {\n  float: right;\n}\n.no-bullets[data-v-418aa29e] {\n    list-style-type: none;\n}\n.mt-2[data-v-418aa29e] {\n  width: 100%;\n}\n.inputFileButton[data-v-418aa29e] {\n  float: left;\n}\n.list-block[data-v-418aa29e] {\n    padding: 0px 0px 0px 0px;\n    margin: auto;\n    width: 100%\n}\n.button-setting[data-v-418aa29e] {\n  width: 80px;\n}\nul[data-v-418aa29e] {\n  margin-left: -35px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-418aa29e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/rights/RightsPage.vue
// module id = 1542
// module chunks = 2